import { ApplicationRef, Component, HostListener, inject, OnInit, DOCUMENT, isDevMode, PLATFORM_ID } from '@angular/core';
import { NewsletterComponent } from '../../../../shared/components/newsletter/newsletter.component';
import { FooterComponent } from '../../../../core/layout/footer.component';
import { CategoryComponent } from '../category/category.component';
import { SliderComponent } from '../slider/slider.component';
import { HomeServiceService } from '../../services/home-service.service';
import { AsyncPipe, CurrencyPipe, isPlatformBrowser, JsonPipe, NgOptimizedImage } from '@angular/common';
import { ImgProductSizePipe } from '../../../../core/pipes/img-product-size.pipe';
import { environment } from '../../../../../environments/environment.development';
import { RouterModule } from '@angular/router';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { Product, ListProduct } from '../../../../core/models/product';
import { StripeSetupIntentsComponent } from '../../../../shared/components/stripe-setup-intents/stripe-setup-intents.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';

import { NgxNotifier, NgxNotifierService } from 'ngx-notifier';

// import { faHouse } from "@awesome.me/kit-c6f1b0c8cf/icons/slab/regular";


// import { Socket } from 'ngx-socket-io';
// import { SocketService } from '../../../../shared/service/socket.service';



@Component({
  selector: 'app-home',
  imports: [NewsletterComponent, FooterComponent, CategoryComponent, SliderComponent, CurrencyPipe, AsyncPipe, ImgProductSizePipe, RouterModule, NgOptimizedImage, StripeSetupIntentsComponent, FontAwesomeModule, JsonPipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: true
})
export class HomeComponent implements OnInit {

  platform = inject(PLATFORM_ID);
  // default
  private readonly gaService = inject(GoogleAnalyticsService);
  private readonly document = inject(DOCUMENT);
  private readonly window = this.document?.defaultView;
  productList: any;
  productListStock: any = [];
  // size = window.innerWidth;
  size: any = this.window?.innerWidth;
  iconSpinner = faSpinner;
  load = true;
  constructor(
    private homeService: HomeServiceService,
    // private socketService: SocketService,
    private appRef: ApplicationRef,
    private ngxNotifierService: NgxNotifierService

  ) {

    // this.socketService.getMessage().subscribe(res => { 
    //   
    // })


    // this.socket.fromEvent('message')

    // Emit events
    // this.socket.emit('message', 'Hello from Angular!');

    // this.socket.on('message',res=>{
    //   
    // })
    // this.socket.emit('message', 'hola')
    // if (environment.closed) {
    //   window.location.href = 'closed';
    // })

    // this.socketService.getPm().subscribe(res => {
    //   
    // })



  }
  ngOnInit(): void {

    if (isPlatformBrowser(this.platform)) {
      this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const body = {
      where: 'status',
      conditions: '==',
      value: 1,
      limit: 4,
      fieldOrder: 'status',
      orderBy: 'desc',
    };
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.homeService.getProductNews({ limit: 4 }).subscribe((res) => {
      // !usar signal computed para mostrar los valores 
      // !singal para actulozar los productos
      // res.data?.forEach(element => {
      //   
      //   element?.price_currency!.forEach(price => {
      //     
      //     const comision = +price.regular_price! * .036;
      //     const comisionMeses = +price.regular_price! * .0457;
      //     
      //     price.regular_price = Math.ceil(comisionMeses + +price.regular_price!);
      //   });
      // });

      this.productList = res.data;
      this.load = false;
      this.productList.forEach((element) => {
        element.image.forEach((img) => {

        });
        // this.img.transform('dsa', this.size)
      });

      //
    });

    this.homeService.getProductStock(body).subscribe((res) => {
      // res.data?.forEach(element => {
      //   
      //   element?.price_currency!.forEach(price => {
      //     
      //     const comision = +price.regular_price! * .036;
      //     const comisionMeses = +price.regular_price! * .0457;
      //     
      //     price.regular_price = Math.ceil(comisionMeses + +price.regular_price!);
      //   });
      // });

      this.productListStock = res.data;

      //
    });

    this.gaService.pageView('/home', {
      title: 'Page Home Etoy Republic',
    });

  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.size = window.innerWidth;

    // this.screenHeight = window.innerHeight;
  }
  emit(msg: string) {
    // this.socketService.emitMessage('hola')
  }
}
